module.exports = __webpack_public_path__ + "img/thumb-jordan-on.35f7088e.jpg";